import { Action, createReducer, on } from '@ngrx/store';
import * as EmotesActions from '../emotes/emotes.actions';
import { INIT_EMOTE_STATE, EmotesCollection } from './emotes.state';

const _emotesReducer = createReducer(

    INIT_EMOTE_STATE,

    on(
        EmotesActions.emotesLoadedAction,
        (state, action) => ({
            ...state,
            emotes: action.emojis,
        })
    ),

    on(
        EmotesActions.emotesCountUpdateAction,
        (state, action) => ({
            ...state,
            emojiCount: action.count,
        })
    ),

    on(
        EmotesActions.emotesCountResetAction,
        (state, action) => ({
            ...state,
            emojiCount: action.count,
        })
    ),

)

export function emotesReducer(state: EmotesCollection, action: Action) {
    return _emotesReducer(state, action);
}
